<!-- IMPORTANT: This file need to be kept in sync with /src/routes/[entry=entry]/+page.svelte -->
<script>
  import Entry from "#lib/Entry.svelte";
  import PageError from "#lib/PageError.svelte";
  let { data } = $props();
</script>

{#if data.status !== 200}
  <PageError status={data.status} message={data.message} />
{:else}
  <Entry raw_entry={data.entry} is_homepage={data.is_homepage} />
{/if}
